module.exports = __webpack_public_path__ + "officialStatic/img/product-yyzt.63b813f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-yyzt.png
// module id = JWqp
// module chunks = 0